import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    id: undefined, // optional - Mã tự sinh
    name: undefined, // required - Tên email
    code: undefined, // required - Mã
    content: undefined, // required - Nội dung template
    note: undefined, // optional - Nội dung ghi chú
    history: [ // required - Lịch sử chỉnh sửa
    {
        time: undefined, // required - Thời điểm cập nhật
        uid: undefined, // required, ref: mushroom_user - Mã người cập nhật
    }]
};

model.dataMail = {
  test: {
    from: undefined,
    cc: undefined, 
    bcc: undefined, 
    replyTo: undefined,
  },
  prod: {
    from: undefined,
    cc: undefined, 
    bcc: undefined, 
    replyTo: undefined,
  },
  to: undefined, 
  subject: undefined, 
  content: undefined,
};

// validation form
model.validForm = {
  name: [ValidService.required],
  code: [ValidService.required, ValidService.requiredChange],
  content: [ValidService.required],
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "code",
  defaultSort: ["code", "ascending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      name: "",
      code: "",
    },
    operator: {
      name: ":regex_i:",
      code: ":regex_i:",
    },
  },
};

export default model;
